import * as React from "react";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { EWizardLinterStatus, WizardLinter } from "../../../../../../Shared/Process/Process/WizardLinter";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { CashProductDeclarations } from "../../Review/Component/CashProductDeclarations";
import { InstrumentSelection } from "../../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";

interface IDeclarationsProps extends IProcessComponentProps {
    data: ApplyModel;
}

interface IDeclarationsState {
    hasChecked: boolean;
    isCashDeclarationChecked: boolean;
}

export class Declarations extends ProcessComponent<IDeclarationsProps, IDeclarationsState> {
    constructor(props: IDeclarationsProps) {
        super(props);
        this.state = {
            hasChecked: props.isReview,
            isCashDeclarationChecked: props.isReview,
        };
    }

    handleCashDeclarationChange = (event) => {
        this.setState({ isCashDeclarationChecked: event });
    };

    private getCashProductInvestments(): Array<InstrumentSelection> {
        const applyModelCashProducts: Array<InstrumentSelection> =
            (this.props.data as ApplyModel)?.GiaModel?.InstrumentSelections?.Instruments?.filter(
                (x) => x.Instrument.Type === ProductType.CashProduct
            ) ?? [];

        const giaContributionModelCashProducts: Array<InstrumentSelection> =
            (this.props.data as GiaContributionModel)?.Contribution?.InstrumentSelections?.Instruments?.filter(
                (x) => x.Instrument.Type === ProductType.CashProduct
            ) ?? [];

        return applyModelCashProducts.concat(giaContributionModelCashProducts);
    }

    private hasCashProducts(): boolean {
        var cashProducts = this.getCashProductInvestments();
        return cashProducts.length > 0;
    }

    isValid() {
        if (!this.state.hasChecked || (this.hasCashProducts() && !this.state.isCashDeclarationChecked)) {
            this.props.showErrorMsgPopUp(["You must accept all items to continue"], true);
        }
        return super.isValid() && this.state.hasChecked;
    }

    private renderDeclarations() {
        return (
            <>
                <WizardLinter status={EWizardLinterStatus.PleaseReview} enabled={true}>
                    <h2 className="mb-22">Declarations</h2>
                </WizardLinter>
                <p className="checked-paragraph">I confirm that</p>
                <ol className="ml-15">
                    <li className="mb-15">
                        I have provided my client with all pre-sale information required under applicable laws and regulations, including (where applicable) the relevant
                        <ul>
                            <li className="mb-15">KFDs and KFIs;</li>
                            <li className="mb-15">KIDs, KIIDs and charges information documents (as applicable); and</li>
                            <li className="mb-15">SDR and investment label information documents (as applicable)</li>
                        </ul>
                        <div>
                            and that my client has had a reasonable opportunity to read these.
                        </div>
                    </li>
                    <li>
                        I will ensure that my client will meet the eligibility criteria of any investment held in their account as described in the relevant investment documentation.
                    </li>

                </ol>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Confirm all",
                            disabled: this.props.isReview,
                            value: this.state.hasChecked,
                            onChange: (v) => {
                                if (v) {
                                    this.setState({ hasChecked: true });
                                } else {
                                    this.setState({ hasChecked: false });
                                }
                            },
                        },
                    ]}
                />
                {this.hasCashProducts() && (
                    <CashProductDeclarations
                        instrumentCodes={this.getCashProductInvestments().map((x) => x.Instrument.ProductCode)}
                        isCashDeclarationChecked={this.state.isCashDeclarationChecked}
                        onCashDeclarationChanged={this.handleCashDeclarationChange}
                    />
                )}
            </>
        );
    }

    render() {
        return <>{this.renderDeclarations()}</>;
    }
}
